module.exports = __webpack_public_path__ + "img/map.5637579e.svg";